<template>
  <a-spin :spinning="loading">
    <a-row>
      <apexchart height="400px"  type="pie" :options="chartOptions" :series="chartSeries"></apexchart>
    </a-row>
  </a-spin>
</template>

<script>
import utils from '../service/service.js'
import detailHover from "@/components/DetailHover.vue";
import moment from "moment";

export default {
  name: 'StatusSummary',
  components: {
  },
  props: {
    mailing: {}
  },
  mixins:[utils],
  data() {
    return {
      chartOptions: {
        title: {
          text: 'Status',
        },
        chart: {
          id: 'vuechart-example2'
        },
        colors:['#5fad56','#F2C14E','#F78154','#4D9078','#B4436C'],
        labels: ["Recibido","Spam", "Rebote", "Lista Negra", "Desconocido"],
        legend: {
          show: true,
        },
        tooltip: {
          custom: function({series, seriesIndex, dataPointIndex, w}) {

            const l = {
              'Recibido': 'El correo fue recibido con éxito',
              'Spam': 'El servdior de correo del destinatorio marcó el correo cómo spam',
              'Rebote': 'El servidor de correo del destinatario rechazó permanentemente el correo',
              'Lista Negra': 'El destinatario esta desuscripto de este tipo de correo',
              'Desconocido': "No hay información"
            }

            const num = w.globals.initialSeries[seriesIndex];
            const label = w.globals.labels[seriesIndex]
            return `<div style="padding: 5px">${label}: ${num}<p style="font-size: 10px">${l[label]}</p></div>`;
          }

        }
      },
      chartSeries: [],
      loading: false,
    }
  },
  mounted: function() {
    this.plot()
  },
  methods:{
    plot: function() {
      const temp = [
        parseInt(this.mailing.deliveries),
        parseInt(this.mailing.complaints),
        parseInt(this.mailing.bounces),
        parseInt(this.mailing.blacklists),
      ]
      const unknown = parseInt(this.mailing.cantidad_envios) - temp.reduce((acc, curr)=>acc+=curr)
      temp.push(unknown)
      this.chartSeries = temp;
    }
  },
  watch: {
    mailing: function() {
      this.plot();
    }
  }

}
</script>

<style>
.apexcharts-legend {
  text-align: left;
}
</style>